export const getFirstPathnameInUrl = location =>
  __CLIENT__ && location.pathname.split('/')[1];
